const styles = {
    glass:" bg-gradient-to-b from-color-5 to-color-6   dark:bg-gradient-to-b dark:from-color-9 dark:to-color-10 dark:bg-opacity-60 backdrop-blur-2xl"
}
export default styles;